<template>
  <b-modal
    title="Request Resume"
    centered
    hide-footer
    v-model="show"
    class="pa-4"
    :style="'width: 708px !important;'"
    @hide="onHide"
  >
    <div v-if="candidate">
      <p class="mt-0 mb-3">
        Request access to
        <b>{{ candidate.name || candidate.full_name }}</b>
        's Tradie Pass profile and resume?
      </p>
      <p
        v-if="candidate.resume_request_status === 'declined'"
        class="text-muted small mb-3"
      >
        This candidate declined a previous request. They may have done so by
        mistake — sending another asks them to reconsider.
      </p>
      <p class="text-muted small mb-3">
        They'll be notified and can accept or decline. You'll be able to view
        their contact details and resume once they accept.
      </p>
    </div>

    <b-alert :show="!!error" variant="danger" class="mb-3">{{ error }}</b-alert>

    <div class="d-flex justify-content-center pt-2" style="gap: 0.5rem">
      <b-button variant="primary" :disabled="busy" @click="onConfirm">
        <b-spinner v-if="busy" small class="mr-1" />
        Send Request
      </b-button>
      <b-button variant="outline-secondary" :disabled="busy" @click="onClose">
        Cancel
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ResumeRequestModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    candidate: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      busy: false,
      error: '',
    }
  },

  computed: {
    show: {
      get() {
        return this.showModal
      },
      set() {
        this.$emit('closeModal')
      },
    },
  },

  watch: {
    showModal(val) {
      if (val) this.error = ''
    },
  },

  methods: {
    ...mapActions('candidate', ['sendResumeRequest']),

    onHide() {
      this.$emit('closeModal')
    },

    onClose() {
      this.$emit('closeModal')
    },

    async onConfirm() {
      if (!this.candidate || this.busy) return
      this.busy = true
      this.error = ''
      try {
        await this.sendResumeRequest(this.candidate.id)
        this.$emit('sent', this.candidate.id)
      } catch (err) {
        this.error =
          (err && err.data && err.data.message) ||
          'Failed to send resume request.'
      } finally {
        this.busy = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
strong {
  color: inherit;
}
</style>
